<app-modal-container
    #modalContainer
    (onClose)="close()"
>
<!--  <div class="modal-header">-->
<!--    -->

<!--  </div>-->
  <div class="modal-body">
    <div class="title-holder">
      <span class="icon">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.5442 10.4154L9.85476 21.1049H0.771472V12.0216L11.4609 1.33211L20.5442 10.4154Z" fill="url(#paint0_linear_31033_29259)" stroke="url(#paint1_linear_31033_29259)"/>
          <defs>
          <linearGradient id="paint0_linear_31033_29259" x1="16.3562" y1="5.52024" x2="-0.0801888" y2="-4.61088" gradientUnits="userSpaceOnUse">
          <stop/>
          <stop offset="1" stop-color="white"/>
          </linearGradient>
          <linearGradient id="paint1_linear_31033_29259" x1="20.8329" y1="7.52248" x2="9.6957" y2="4.41288" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" stop-opacity="0"/>
          <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
          <stop offset="1" stop-color="white" stop-opacity="0"/>
          </linearGradient>
          </defs>
        </svg>
      </span>
      <h2>Керувати персональною пропозицією</h2>
    </div>

    <button class="btn btn-black btn-cancel" (click)="cancel()" *ngIf="canCancelOffering && isActiveOffering">Скасувати</button>

    <h3 class="subheader">Запропоновано</h3>

    <div class="request-data-holder">
      <div class="">

        <div class="flex">
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Кількість у пропозиції</span>
              <p class="content">
                <ng-container *ngIf="personalOffer; else emptyData">
                  {{ personalOffer.offeredAmount }}
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <span class="subtitle">Від закладу охорони здоров'я</span>
              <p class="content">
                <ng-container *ngIf="personalOffer; else emptyData">
                  {{ getOrganisationName(personalOffer.organizationId) }}
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-5">
            <div class="form-group" *ngIf="personalOffer && personalOffer.status === 'CANCELLED'">
              <span class="subtitle">Причина скасування</span>
              <p class="content">
                <ng-container>
                  {{ personalOffer.reasonForCancellation }}
                </ng-container>
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <h3 class="subheader">Згідно з запитом</h3>

    <div class="request-data-form">
      <div class="">

        <div class="flex">
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Статус</span>
              <p class="content">
                <ng-container *ngIf="redistributionRequest; else emptyData">
                  <app-redistribution-status  [status]="redistributionRequest.status"/>
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Медичний товар</span>
              <p class="content">
                <ng-container *ngIf="redistributionRequest; else emptyData">
                  {{ redistributionRequest.tradeName }}
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Напрям</span>
              <p class="content">
                <ng-container *ngIf="redistributionRequest; else emptyData">
                  {{ redistributionRequest.direction }}
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Кількість у запиті</span>
              <p class="content">
                <ng-container *ngIf="redistributionRequest; else emptyData">
                  {{ redistributionRequest.amount }}
                </ng-container>
              </p>
            </div>
          </div>
        </div>

        <div class="flex">
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Дозування</span>
              <p class="content">
                <ng-container *ngIf="personalOffer; else emptyData">
                  {{ personalOffer.medicineMedicalDevice.dosage === null ? '-' : personalOffer.medicineMedicalDevice.dosage}}
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Серія/Каталожний номер</span>
              <p class="content">
                <ng-container *ngIf="personalOffer; else emptyData">
                  {{ personalOffer.medicineMedicalDevice.series === null ? '-' : personalOffer.medicineMedicalDevice.series }}
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Придатний до</span>
              <p class="content">
                <ng-container *ngIf="personalOffer; else emptyData">
                  {{ personalOffer.medicineMedicalDevice.dueDate === null ? '-' : personalOffer.medicineMedicalDevice.dueDate | date: 'MM.yyyy'}}
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Мін. облікова одиниця</span>
              <p class="content">
                <ng-container *ngIf="personalOffer; else emptyData">
                  {{ personalOffer.medicineMedicalDevice.minUnit === null ? '-' : personalOffer.medicineMedicalDevice.minUnit }}
                </ng-container>
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="flex justify-content-center">
      <button class="btn btn-grey" (click)="reject()" *ngIf="canManageOffering && isActiveOffering">
        Відхилити
        <span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6693 1.3335C13.7326 1.3335 14.6049 2.16788 14.6659 3.21617L14.6693 3.3335V10.0002C14.6693 11.0634 13.8349 11.9358 12.7866 11.9968L12.6693 12.0002H10.3359L8.53594 14.4002C8.40994 14.5682 8.2126 14.6668 8.0026 14.6668C7.81885 14.6668 7.6448 14.5913 7.51975 14.4599L7.46927 14.4002L5.66927 12.0002H3.33594C2.27265 12.0002 1.40029 11.1658 1.33934 10.1175L1.33594 10.0002V3.3335C1.33594 2.27021 2.17032 1.39785 3.21861 1.3369L3.33594 1.3335H12.6693ZM12.6693 2.66683H3.33594C2.99484 2.66683 2.71238 2.92493 2.67377 3.25591L2.66927 3.3335V10.0002C2.66927 10.3413 2.92737 10.6237 3.25835 10.6623L3.33594 10.6668H6.0026C6.18635 10.6668 6.36041 10.7424 6.48546 10.8738L6.53594 10.9335L8.0026 12.8888L9.46927 10.9335C9.57952 10.7865 9.74438 10.6926 9.92456 10.6714L10.0026 10.6668H12.6693C13.0104 10.6668 13.2928 10.4087 13.3314 10.0778L13.3359 10.0002V3.3335C13.3359 2.9924 13.0778 2.70994 12.7469 2.67133L12.6693 2.66683ZM11.3359 7.3335C11.7039 7.3335 12.0026 7.63216 12.0026 8.00016C12.0026 8.34188 11.7451 8.62381 11.4136 8.66234L11.3359 8.66683H4.66927C4.30127 8.66683 4.0026 8.36816 4.0026 8.00016C4.0026 7.65845 4.26013 7.37652 4.59156 7.33798L4.66927 7.3335H11.3359ZM11.3359 4.66683C11.7039 4.66683 12.0026 4.9655 12.0026 5.3335C12.0026 5.67521 11.7451 5.95714 11.4136 5.99567L11.3359 6.00016H4.66927C4.30127 6.00016 4.0026 5.7015 4.0026 5.3335C4.0026 4.99178 4.26013 4.70985 4.59156 4.67132L4.66927 4.66683H11.3359Z" fill="black"/>
          </svg>
        </span>
      </button>
      <button class="btn btn-black" (click)="accept()" *ngIf="canManageOffering && isActiveOffering">Прийняти
        <span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_30975_45064)">
            <path d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z" fill="white"/>
            <path d="M5 8L7 10L11 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_30975_45064">
            <rect width="16" height="16" fill="white"/>
            </clipPath>
            </defs>
          </svg>
        </span>
      </button>
    </div>

  </div>

  <ng-template #emptyData>-</ng-template>

  <app-loading-animation *ngIf="isLoading"></app-loading-animation>

</app-modal-container>